export default "__VITE_ASSET__DRXXDFFj__"